import { fork } from 'redux-saga/effects';
import { filtersConfigWatcher } from './filtersSaga';
import { vehiclesWatcher } from './vehiclesSagas';
import { getFieldsWatcher } from './getFieldsSagas';
import { getFieldsByIdWatcher } from './getFieldsByIdSagas';

/* Card */
import { vehicleCardConfigWatcher } from './vehicleCardSaga';
//import { updateVehicleWatcher } from './updateVehicleSagas';
//import { archivingVehicleWatcher } from './archivingVehicleSagas';

/* Add Card */
import { autoSearchWatcher } from './autoSearchSagas';
// import { addVehicleWatcher } from './addVehicleSagas';

export default function* Vehicles() {
  yield fork(filtersConfigWatcher);

  yield fork(vehiclesWatcher);
  yield fork(getFieldsWatcher);
  yield fork(getFieldsByIdWatcher);

  yield fork(vehicleCardConfigWatcher);

  /* Card */
  //yield fork(updateVehicleWatcher);
  //yield fork(archivingVehicleWatcher);

  /* Add Card */
  // yield fork(addVehicleWatcher);
  yield fork(autoSearchWatcher);
}
